import {LoginAsPermission} from "@/types/permissions/login-as-permissions";

export class LoginAsRole {
    public id: number | null;
    public name: string;
    public description: string;
    public loginAsPermissions: LoginAsPermission[];

    constructor(data: LoginAsRoleData | void) {
        if (data === undefined) {
            this.id = null;
            this.name = "";
            this.description = "";
            this.loginAsPermissions = [];
        } else {
            this.id = data.id;
            this.name = data.name;
            this.description = data.description;

            this.loginAsPermissions = [];
            if (data.loginAsPermissions !== undefined) {
                data.loginAsPermissions.forEach(loginAsPermission => this.loginAsPermissions.push((new LoginAsPermission(loginAsPermission))));
            }
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.name = '';
        this.description = '';
        this.loginAsPermissions = [];
    }

    public serializeData(): LoginAsRoleData {
        const data: LoginAsRoleData = {
            id: this.id,
            name: this.name,
            description: this.description,
            loginAsPermissions: [],
        };

        this.loginAsPermissions.forEach(permission => {
            data.loginAsPermissions?.push(permission.serializeData());
        });
        return data;
    }
}

export type LoginAsRoleData = {
    id: number | null;
    name: string;
    description: string;
    loginAsPermissions: LoginAsPermission[] | undefined;
}
